import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '@ui-lib/components';

@Injectable()
export class ExceptionInterceptor implements HttpInterceptor {
  private readonly internalServerError: string =
    'Внутренняя ошибка сервера. Попробуйте позже, мы устраняем проблему.';
  private readonly forbiddenErrorTitle: string = 'Нет доступа';
  private readonly forbiddenErrorMessage: string =
    'У вас нет разрешения на выполнение операции. Код ошибки: 403 Доступ запрещен.';

  constructor(private readonly toastService: ToastService) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        switch (error.status) {
          case 403:
            this.toastService.error({
              title: this.forbiddenErrorTitle,
              message: this.forbiddenErrorMessage,
            });
            return throwError(() => error);
          case 500:
            this.toastService.error({ message: this.internalServerError });
            return EMPTY;
        }

        return throwError(() => error);
      }),
    );
  }
}
